module.exports = __webpack_public_path__ + "img/brazino.09b6d6c2.svg";